module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("After a successful career in journalism, Mike Tomkies returned to his childhood love of nature and spent over thirty years living in remote places in the Scottish Highlands, Canada and Spain. During this time, he wrote a number of best-selling books, including "), _c('em', [_vm._v("Alone in the Wilderness, A Last Wild Place, Out of the Wild, On Wing and Wild Water, Wildcat Haven")]), _vm._v(" and "), _c('em', [_vm._v("Moobli")]), _vm._v(". He died in 2016.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0